export const ISO_MAP: Record<string, string> = {
  ARG: 'ar', BRA: 'br', COL: 'co', ECU: 'ec', PAR: 'py', URU: 'uy',
  GER: 'de', AUT: 'at', BEL: 'be', BIH: 'ba', CRO: 'hr', SCO: 'gb-sct',
  ESP: 'es', FRA: 'fr', NED: 'nl', ENG: 'gb-eng', NOR: 'no', POR: 'pt',
  CZE: 'cz', SWE: 'se', SUI: 'ch', TUR: 'tr',
  CAN: 'ca', CUW: 'cw', USA: 'us', HAI: 'ht', MEX: 'mx', PAN: 'pa',
  RSA: 'za', ALG: 'dz', CPV: 'cv', CIV: 'ci', EGY: 'eg', GHA: 'gh',
  MAR: 'ma', COD: 'cd', SEN: 'sn', TUN: 'tn',
  KSA: 'sa', AUS: 'au', QAT: 'qa', KOR: 'kr', IRN: 'ir', IRQ: 'iq',
  JPN: 'jp', JOR: 'jo', UZB: 'uz', NZL: 'nz',
};

export function getFlagClass(code: string): string | null {
  const iso = ISO_MAP[code];
  return iso ? `fi fi-${iso} fis` : null;
}
